<template>
    <v-container>
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-layout row wrap :class="classDisabledview">
            <v-flex xs12 sm12 md12>
                <v-card flat class="text-xs-center ma-3" width="100%">

                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white; font-size:small"><v-icon size="14" color="white"> mdi-information-variant </v-icon> VOLANTE DE ASISTENCIA JURIDICA</span>
                    </v-card-title>
                </v-card>
            </v-flex>

            <Asegurado v-if="show" 
                       :validatermino="validatermino" 
                       :validaConclusion="validaConclusion"
                       :svresponsabled="svresponsabled"
                       @reload="reload"></Asegurado>
            <Tercero v-if="show" 
                     :validatermino="validatermino" 
                     :validaConclusion="validaConclusion"
                     :svresponsabled="svresponsabled"
                     @reload="reload"></Tercero>




        </v-layout>
    </v-container>
</template>


<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import Reporte from "@/services/ExpJur/ExpJur.service.js";
    import Asegurado from "@/components/pages/ExpJur/components/Asegurado.vue";
    import Tercero from "@/components/pages/ExpJur/components/Tercero.vue";
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Asegurado,
            Tercero,
        },
        data() {
            return {
                showcargando: true,
                show: false,
                validatermino: false,
                classDisabledview: '',
                validaConclusion: false,
                svresponsabled: false,
                displayInputs: {
                    nrreporte: 0,
                    svindice: 0
                },
            }
        },
        methods: {
            ...mapMutations(["changeReporteMenuOption"]),
            reload(val) {
                this.$emit('ReloadEncabezado');
            }
        },
        async mounted() {
            this.changeReporteMenuOption("Volante Jur.");
            let datos = await MetodosGenerales.obtenerSessionReporte("reporte");
            this.displayInputs = {
                nrreporte: datos.nrreporte,
                svindice: datos.svindice
            };
            if (datos.aiclave == 1) {
                let datosvalida = await Reporte.obtenerDatosValidaVolante(this);
                let validaConc = await MetodosGenerales.getReporteEstatus(this);
                if (validaConc == 2) { // si es 2 es porque esta cerrado
                    this.validaConclusion = true;
                }
                if (datosvalida[0].svresponsable != null) {
                    this.svresponsabled = true;
                }

                if (datosvalida[0].svfhtermino != null) {
                    this.classDisabledview = '';
                    this.validatermino = true;
                }
                else if (datosvalida[0].svfhtermino == null && !datosvalida[0].permisoVolante) {
                    this.classDisabledview = 'h-screen z-50 overflow-hidden';
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Para poder acceder al Volante jurídico es necesario tener fecha de término capturada',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        confirmButtonText: 'Aceptar',
                        showCancelButton: false,
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            this.changeReporteMenuOption('Detalle General');
                            sessionStorage.setItem("Volante", 'DetalleExpJur');


                            //this.changeReporteMenuOption('DetalleExpJur');
                            //sessionStorage.setItem("Volante", 'DetalleExpJur');
                            //this.$router.push({ name: 'DetalleExpJur' });


                            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.displayInputs);

                            this.$router.push({ path: asistenciaurl + '/ReporteDetalle' });

                        }
                    })
                    this.validatermino = false;
                }
                else if (datosvalida[0].svfhtermino == null && datosvalida[0].permisoVolante) {
                    this.classDisabledview = '';
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Solo podrá visualizar el Volante jurídico ya que no tiene fecha de término capturada',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        confirmButtonText: 'Aceptar',
                        showCancelButton: false,
                    })
                    this.validatermino = false;
                }
                this.show = true;


                setTimeout(() => {
                    this.showcargando = false;
                }, 2000);

            }


        }
    }

</script>